import { Injectable } from '@angular/core';
import { ContextService } from '../application/context.service';
import { APIService } from '../application/api.service';
import { IAppContext } from 'src/app/framework/interfaces';
import * as FW from "../../framework/core";
import { WarningLevel } from 'src/app/framework/enums';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IQueueFile } from 'src/app/models/IQueueFile';

@Injectable({
    providedIn: 'root'
})
export class AdminService {
    public get serviceName(): string { return "Admin" };

    constructor(public context: ContextService, private api: APIService) {
    }

    public listQueueFiles(): Observable<FW.Envelope<IQueueFile[]>> {
        const ctx: IAppContext = this.context.join(this.serviceName);
        return this.api.get(ctx, '/queue/files/list');
    }
}